import axios from 'axios'
import store from '@/store'
import router from '@/router'

const apiBaseUrl = process.env.VUE_APP_API_BASE_URL 

const http = axios.create({
  baseURL: apiBaseUrl,
  timeout: 15000,
  headers: { 'Content-Type': 'application/json' }
})

http.interceptors.request.use(config => {
  const token = store.getters['auth/accessToken']
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

http.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      store.dispatch('auth/logout')
      router.push({ name: 'Login' })
    }
    return Promise.reject(error)
  }
)

export default http
